// extracted by mini-css-extract-plugin
export default {"previewBodyElement":"PreviewBodyElement_previewBodyElement__F3z6S"};